import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

export default function BarChartGBASmall(props) {
  const { forecastDate, updateDate, cityData, gbaData } = props;

  if (!Array.isArray(cityData) || !Array.isArray(gbaData)) return null;

  const cityNames = cityData.map((item) => item.city).concat("珠三角九市");
  const gdpValues = cityData.map((item) => item.value).concat(gbaData[0]);

  return (
    <div className="smallBarChart">
      <h3>{forecastDate} 预测值</h3>
      <BarChart
        height={250}
        xAxis={[
          {
            scaleType: "band",
            data: cityNames,
            tickLabelStyle: {
              angle: 45,
              fontSize: 8,
              textAnchor: "middle", // 确保文字居中旋转
            },
          },
        ]}
        yAxis={[
          {
            tickLabelStyle: {
              fontSize: 11,
            },
          },
        ]}
        series={[
          {
            label: "GDP增速预测值",
            data: gdpValues,
            color: "#392f30",
          },
        ]}
        margin={{ top: 10, right: 10, bottom: 60, left: 20 }} // 尤其 bottom 要够大
      />
      <p className="updateDate" style={{ marginTop: "10px" }}>
        注：图中为累计同比数据，珠三角九市的GDP预测方法与广深相关经济指标存在差异，详见“常见问题”与“相关研究”说明。
      </p>
      <p className="updateDate">更新时间：{updateDate}</p>
    </div>
  );
}
